import moment from 'moment';

export function formatDateTime(value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY hh:mm");
  } else
    return '';
}

export function formatDate (value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY");
  } else
    return '';
}

export function formatIndiceCadastral(value){

    if (!value) return "";
    else {     
      value = value.replace(
        /(\d{3})([A-Za-z0-9 ]{4})([A-Za-z0-9 ]{4})(\d{3})([A-Za-z0-9]{1})$/,
        "$1.$2.$3.$4.$5"
      );
      return value;
    }
}
export function formatLancamento(value){
  if (!value) return "";
  else {     
    value = value.replace(/(\d{2})(\d{3})(\d{2})(\d{7})$/, "$1.$2.$3-$4");
    return value;
  }
}
export function formatCurrency (value) {
  let formatter = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
  });
  return formatter.format(value);
}
export function formatCPFCNPJ(value) {
  if (!value) return "";
  else {
    value = value.replace(/[^\d]+/g, "");

    if (value.length === 11) {
      value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
      return value;
    } else if (value.length === 14) {
      value = value.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        "$1.$2.$3/$4-$5"
      );
      return value;
    }
  }
}
